import Vue from 'vue'
import Router from 'vue-router'

import film from './views/film.vue'
import design from './views/design.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'info',
      meta: {logo: 'images/logo-info.png'},
      component: function () {
        return import('./views/info.vue')
      }
    },
    {
      path: '/film',
      name: 'film',
      meta: {logo: 'images/logo-movie.png'},
      component: film
    },
    {
      path: '/ontwerp',
      name: 'design',
      meta: {logo: 'images/logo-design.png'},
      component: design
    }
  ]
})
